/* eslint-disable import/prefer-default-export */
/* eslint-disable no-param-reassign */
import getServiceDateFromResyToken from '../../../../../ui-kitchen/src/utils/resyToken';
import { getURLSearchParams, setSearchParams } from '../../../../../ui-kitchen/src/utils/searchParamUtils';

const assessSoldOut = (selectedISODate, scheduled = []) => {
  const e = scheduled.find((f) => f.date === selectedISODate);
  return e && e.inventory === 'sold-out';
};

const findContent = (venue, contentName) => venue.content?.find((content) => content.name === contentName);

const hasActiveSafetyCategories = (safetyCategories = []) => safetyCategories.some((category) => category.items.length > 0);

const initFbPixel = (pixelId) => {
  if (window.fbq && pixelId) {
    window.fbq('dataProcessingOptions', ['LDU'], 0, 0);
    window.fbq('init', pixelId);
  }
};

const filterInventory = (scheduledVenueInventory, startDate, endDate) => scheduledVenueInventory
  .filter((itemFilter) => (moment(itemFilter.date.trim(), 'YYYY-MM-DD')
    .isSameOrAfter(moment(startDate.trim(), 'YYYY-MM-DD'))
&& moment(itemFilter.date.trim(), 'YYYY-MM-DD')
  .isSameOrBefore(moment(endDate.trim(), 'YYYY-MM-DD'))));

const reduceInventoryAmex = (venueInventory, startDate, endDate) => filterInventory(venueInventory, startDate, endDate)
  .reduce((map, item) => {
  // eslint-disable-next-line no-param-reassign
    map[item.date] = item.inventory;
    return map;
  }, {});

const reduceInventory = (venueInventory) => venueInventory.scheduled.reduce((map, item) => {
  // eslint-disable-next-line no-param-reassign
  map[item.date] = item.inventory;
  return map;
}, {});

const getCustomAffiliationId = (customAffiliation = {}) => customAffiliation?.id || null;

const getCustomAffiliationIdList = (customAffiliation = {}, customAffiliations = [], venueGroup) => {
  const customAffiliationId = getCustomAffiliationId(customAffiliation);
  let list;
  if (customAffiliationId) {
    list = customAffiliations.reduce((result, item) => {
      const venues = (item.id === customAffiliationId)
        ? [...result, ...item.venues]
        : [...result];
      return venues;
    }, []);
  } else {
    list = venueGroup?.venues;
  }
  return list;
};

const getSelectResy = ({
  bookingState,
  featureRecaptcha,
  navigate = () => { },
  openNotify,
  PathBuilder,
  reservations,
  searchParams,
  setRouteBackPath,
  setReservation,
  setDay,
  setPartySize,
  setCanBook,
  setVenueId,
  setVenueName,
  selectedDate,
  selectedQuantity,
  setResyToken,
  venueId,
  venueName,
}) => (config, reservation) => {
  if (reservation) {
    const bookingDay = getServiceDateFromResyToken(reservation.token, selectedDate);
    setReservation(reservation);
    setDay(bookingDay);
    setPartySize(selectedQuantity);
    setCanBook(!!reservations.length);
    setVenueId(venueId);
    setVenueName(venueName);

    const resyToken = searchParams.get('resyToken');
    if (resyToken) {
      setResyToken(resyToken);
    }

    // routing between steps
    if (reservation.hasMenus) {
      PathBuilder.setValues({
        addOnsTemplateId: reservation.templateId,
        eventPath: undefined,
        isGda: reservation.isGda,
        venueId,
      });
      setRouteBackPath(PathBuilder.backPath('AddOns'));
      const nextPath = `/venues/${venueId}/add-ons/${reservation.templateId}`;
      if (featureRecaptcha && !bookingState.captchaResponse) {
        navigate('/captcha');
        setSearchParams('addOns', 'true');
        setSearchParams('venueId', venueId);
        setSearchParams('seats', selectedQuantity);
      } else {
        navigate(nextPath);
      }
    } else {
      PathBuilder.setValues({
        addOnsTemplateId: undefined,
        eventPath: undefined,
        isGda: reservation.isGda,
        venueId,
      });
      setRouteBackPath(PathBuilder.backPath('Summary'));
      const nextPath = '/reservation-details';
      if (featureRecaptcha && !bookingState.captchaResponse) {
        navigate('/captcha');
        setSearchParams('venueId', venueId);
        setSearchParams('seats', selectedQuantity);
      } else {
        navigate(nextPath);
      }
    }
  } else if ('notifyService' in config) {
    openNotify(config.notifyService);
  }
};

const assessNotifyParams = (openNotify) => {
  const params = getURLSearchParams();
  const notifyService = params.get('notifyService');
  if (typeof (notifyService) === 'string') {
    openNotify(notifyService);
  }
  setSearchParams('notifyService', null);
};

export {
  assessNotifyParams,
  assessSoldOut,
  findContent,
  hasActiveSafetyCategories,
  getCustomAffiliationId,
  getCustomAffiliationIdList,
  getSelectResy,
  initFbPixel,
  reduceInventory,
  reduceInventoryAmex,
};
